import { createSlice } from '@reduxjs/toolkit';
import { getConferenceState } from '../base/conference/functions';
import { getParticipantById, isParticipantModerator } from '../base/participants/functions';
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { isBannedChangeName, isEnableBanAllChangeName } from './functions';
export const approveParticipantChangeName = (id) => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const participant = getParticipantById(state, id);
    if (!participant)
        return;
    const isBanned = isBannedChangeName(participant, state);
    if (isBanned) {
        conference?.changeNameModerationApprove(id);
    }
};
export const rejectParticipantChangeName = (id) => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const participant = getParticipantById(state, id);
    if (!participant)
        return;
    const isBanned = isBannedChangeName(participant, state);
    const isModerator = isParticipantModerator(participant);
    if (!isBanned && !isModerator) {
        conference?.changeNameModerationReject(id);
    }
};
export const enableBanAllChangeName = () => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const isBanAll = isEnableBanAllChangeName(state);
    if (!isBanAll) {
        conference?.enableChangeNameModeration();
    }
};
export const disableBanAllChangeName = (id) => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const isBanAll = isEnableBanAllChangeName(state);
    if (isBanAll) {
        conference?.disableChangeNameModeration();
    }
};
const initialState = {
    enabled: false,
    whitelist: {},
    blacklist: {},
    canChangeName: undefined,
    actor: null
};
const changeNameModeration = createSlice({
    name: 'features/changeName-moderation',
    initialState,
    reducers: {
        disableChangeNameModeration: (state, action) => {
            if (state.enabled) {
                state.enabled = false;
                state.actor = action.payload;
                state.canChangeName = undefined;
                state.whitelist = {};
                state.blacklist = {};
            }
        },
        enableChangeNameModeration: (state, action) => {
            if (!state.enabled) {
                state.enabled = true;
                state.actor = action.payload;
                state.canChangeName = undefined;
                state.whitelist = {};
                state.blacklist = {};
            }
        },
        localParticipantApproved: state => {
            state.canChangeName = true;
        },
        localParticipantRejected: state => {
            state.canChangeName = false;
        },
        participantApproved: (state, action) => {
            if (state.enabled) {
                state.whitelist = {
                    ...state.whitelist,
                    [action.payload.jid]: true
                };
            }
            else {
                state.blacklist = {
                    ...state.blacklist,
                    [action.payload.jid]: false
                };
            }
        },
        participantRejected: (state, action) => {
            if (state.enabled) {
                state.whitelist = {
                    ...state.whitelist,
                    [action.payload.jid]: false
                };
            }
            else {
                state.blacklist = {
                    ...state.blacklist,
                    [action.payload.jid]: true
                };
            }
        }
    }
});
ReducerRegistry.register('features/changeName-moderation', changeNameModeration.reducer);
export const { disableChangeNameModeration, enableChangeNameModeration, localParticipantApproved, localParticipantRejected, participantApproved, participantRejected } = changeNameModeration.actions;
export default changeNameModeration.reducer;
